import {
  MESSAGE_SENDER,
  MESSAGE_TYPES,
  // BUTTON_SUB_TYPES,
  BUTTON_TYPES,
} from "./constants"

export const getDefaultMessagesByKey = (key = "web") => {
  const defaultMessgaes = {
    web: [
      // {
      //   cmid: "message1",
      //   type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
      //   sender: MESSAGE_SENDER.CHATBOT,
      //   inputLock: false,
      //   quickReplies: [],
      //   skipLS: true,
      //   send_variable_to_apiai: false,
      //   sendVariableToLS: false,
      //   variable_name: "subscription",
      //   delay: 0,
      //   payload: {
      //     title: "",
      //     subtitle: "Hi, I'm the EF Bot 🤖. We are the best and the coolest. What are you dreaming of ? ✈️ 🌎",
      //     buttons: [
      //       {
      //         type: BUTTON_TYPES.CUSTOM_SOCKET_EVENT,
      //         text: "Live Chat",
      //         eventName: "buttonSelection",
      //         relayData: {
      //           relay_intent: "talk_to_agent",
      //           generative_flag: false
      //         },
      //       },
      //       {
      //         type: BUTTON_TYPES.CUSTOM_SOCKET_EVENT,
      //         text: "Destinations and Courses",
      //         eventName: "buttonSelection",
      //         relayData: {
      //           relay_intent: "destination_and_courses",
      //           generative_flag: false
      //         },
      //       },
      //       {
      //         type: BUTTON_TYPES.CUSTOM_SOCKET_EVENT,
      //         text: "Activities and Experiences",
      //         eventName: "buttonSelection",
      //         relayData: {
      //           relay_intent: "activities_and_experiences",
      //           generative_flag: false
      //         },
      //       },
      //     ],
      //   },
      //   timestamp: new Date(),
      // }
    ],
    android: [
      // {
      //   cmid: "message1",
      //   type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
      //   sender: MESSAGE_SENDER.CHATBOT,
      //   inputLock: false,
      //   quickReplies: [],
      //   skipLS: true,
      //   send_variable_to_apiai: false,
      //   sendVariableToLS: false,
      //   variable_name: "subscription",
      //   delay: 0,
      //   payload: {
      //     title: "Hi, I'm the EF Bot 🤖. We are the best and the coolest. What are you dreaming of ? ✈️ 🌎",
      //     subtitle: "",
      //     buttons: [
      //       {
      //         type: BUTTON_TYPES.CUSTOM_SOCKET_EVENT,
      //         text: "Live Chat",
      //         eventName: "buttonSelection",
      //         relayData: {
      //           relay_intent: "talk_to_agent",
      //           generative_flag: false
      //         },
      //       },
      //       {
      //         type: BUTTON_TYPES.CUSTOM_SOCKET_EVENT,
      //         text: "Destinations and Courses",
      //         eventName: "buttonSelection",
      //         relayData: {
      //           relay_intent: "destination_and_courses",
      //           generative_flag: false
      //         },
      //       },
      //       {
      //         type: BUTTON_TYPES.CUSTOM_SOCKET_EVENT,
      //         text: "Activities and Experiences",
      //         eventName: "buttonSelection",
      //         relayData: {
      //           relay_intent: "activities_and_experiences",
      //           generative_flag: false
      //         },
      //       },
      //     ]
      //   },
      //   timestamp: new Date(),
      // }
    ],
  }
  return defaultMessgaes[key] || []
}
